import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { makeGridGetRowsResponse } from '@cbridge-tools/default-data-grid';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { toApiSort } from '@cbridge-utils/datagrid';
import { SymbolSyntheticAction } from '../symbolSynthetic.action';
import { SymbolSyntheticTranslator } from '../symbolSynthetic.translator';

type IDependencies = IClientApiDependencySegment;

export const loadSymbolSyntheticListEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolSyntheticAction.loadList.started),
  mergeMap((params) => {
    const { resolve, reject, sort, ...payload } = params;

    return dependencies.api.getSyntheticSymbolList({
      ...payload,
      sort: toApiSort(sort),
    }).pipe(
      mergeMap((response) => {
        const { symbols, totalCount, filteredCount } = response;

        const items = symbols.map(SymbolSyntheticTranslator.fromApi);
        resolve?.(makeGridGetRowsResponse(items, filteredCount));

        return [
          SymbolSyntheticAction.loadList.done({ params, result: { items, totalCount, filteredCount } }),
        ];
      }),
      catchApiError((error) => {
        reject?.(error?.description);
        return [
          SymbolSyntheticAction.loadList.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
